export enum MembershipPlanUnavailabilityReason {
  MemberAgeNotMatch = 'MemberAgeNotMatch',
  MemberBirthDateNotDefined = 'MemberBirthDateNotDefined',
  MembershipCollision = 'MembershipCollision',
}
